// removed by extract-text-webpack-plugin
module.exports = {"buttonRow":"_3fwndmQlTuZPpup7fhxSDk"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/buttons/button-row.scss
// module id = 76
// module chunks = 0